<template>
  <div
    class="tree_content area_tree_box"
    :style="
      'position: absolute !important;top: 0px;bottom: 0px;height: unset;' +
        (treeMenuHide != true ? '' : 'width:60px')
    "
    :class="{ 'reset_width-394': isSetConfig }"
  >
    <div v-show="isTitleShow !== true && isTitleShow == undefined">
      <div
        v-show="treeMenuHide != true"
        class="tree_title"
        :class="is_refresh ? 'refreshing' : ''"
        style="
          margin-top: 16px;
          margin-bottom: 16px;
          font-size: 16px;
          margin-left: 16px;
        "
      >
        <div
          v-if="sideflex == true"
          style="display: inline-block; height: 30px; width: 30px"
        >
          <!-- <img @click="sideflexEvent" src="../../../../assets/img/caidanicon.png" /> -->
        </div>
        <span
          v-if="$route.path.indexOf('visual') !== -1"
          class="tree-area-title"
        >
          {{ $t("tree.city") }}
        </span>
        <span v-else>
          {{ $t("tree.title") }}
          {{ onlynoarea == undefined ? " " + allcount + "" : "" }}
        </span>

        <img
          :style="sideflex == true ? 'margin-top: 10px;' : ''"
          class="refresh"
          :class="{ activeRefresh: isloading }"
          src="~@/assets/img/refrsh.png"
          @click="refresh"
        >
      </div>
    </div>
    <div
      v-show="treeMenuHide != true"
      class="custom-tree-container"
      :style="
        'position: absolute;bottom: 0px;width: 100%;height: unset;' +
          (isTitleShow !== true && isTitleShow == undefined
            ? 'top: 52px;'
            : 'top: 20px;')
      "
    >
      <el-dialog
        :title="$t('tree.delmsg')"
        :visible.sync="delDialogVisible"
        width="30%"
        :append-to-body="true"
      >
        <span slot="footer">
          <el-button
            size="small"
            @click="delDialogVisible = false"
          >{{
            $t("tree.cancle")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="delSelect"
          >{{
            $t("tree.submit")
          }}</el-button>
        </span>
      </el-dialog>
      <div
        class="filterText"
        style="display:flex;margin: 0 16px; height: 40px"
      >
        <div style="flex: 1;">
          <el-input
            v-model="filterText"
            :placeholder="$t('tree.placeholdertree')"
            suffix-icon="el-icon-search"
          />
        </div>
        <OppleAuth
          v-if="![-1, 0].includes(Number(gpno)) && showSort && currentLevel !== minLevel"
          code="UpdateArea"
          style="margin-left: 5px;flex: 1;"
        >
          <div>
            <sort-select
              :value="sortType"
              @option-click="sortChangeHandler"
            />
          </div>
        </OppleAuth>
      </div>
      <div
        ref="lyTreeContainer"
        class="ly-tree-container opple-tree-container"
        :class="is_switch ? 'ly-tree-container-check' : ''"
        style="
          position: absolute;
          top: 40px;
          bottom: 0px;
          margin-top: 16px;
          height: unset;
        "
      >
        <!-- <vuescroll> -->
        <el-tree
          ref="tree2"
          v-loading="isloading"
          class="ly-tree-container-tance"
          :data="treeData"
          :props="defaultProps"
          default-expand-all
          :filter-node-method="filterNode"
          :expand-on-click-node="false"
          :highlight-current="true"
          node-key="id"
          :render-content="renderContent"
          :show-checkbox="is_switch"
          :draggable="!!draggable"
          :allow-drag="allowDrag"
          :allow-drop="allowDrop"
          @node-click="handleNode"
          @check="handleCheck"
          @check-change="handleCheckChange"
          @node-drag-start="handleDragStart"
          @node-drag-enter="handleDragEnter"
          @node-drag-leave="handleDragLeave"
          @node-drag-over="handleDragOver"
          @node-drag-end="handleDragEnd"
          @node-drop="handleDrop"
        />
        
        <!-- </vuescroll> -->
      </div>
    </div>
    <!-- 上传区域树excel -->
    <OpDialog 
      class="uploadAreaTreeExcel_dialog"
      :title="$t('tree.exportExcel')"
      :visible="uploadAreaTreeExcelDialogVisible"
      :is-show-btn="false"
      @onClose="hideDialog"
    >
      <div
        class="uploadAreaTreeExcel_content"
      >
        <div class="uploadAreaTreeExcel_content_left">
          <div class="title">
            {{ $t('tree.downloadTemplate') }}
          </div>
          <div class="note">
            {{ $t('tree.excelInfo') }}
          </div>
          <div class="excel">
            <img src="@/assets/img/icon/excel.png" alt="excel">
            <div class="template">
              {{ $t('tree.excelTemplateName') }}
            </div>
          </div>
          <div class="download">
            <div class="button" @click="downloadExcelTemplate">
              {{ $t('tree.downloadTemplate') }}
            </div>
          </div>
        </div>
        <div class="uploadAreaTreeExcel_content_right">
          <div class="header">
            <div class="title">
              {{ $t('tree.uploadTemplate') }}
            </div>
            <div class="note">
              {{ $t('tree.uploadType') }}
            </div>
          </div>
          <div class="upload_container">
            <div
              class="upload_box"
              @dragover.prevent
              @dragenter.prevent
              @drop="handleDropFile"
            >
              <img src="@/assets/img/icon/upload.png" alt="">
              <p>{{ $t('tree.moveHere') }}</p>
              <p>{{ $t('iftttset.or') }}</p>
              <button @click="triggerFileInput">
                {{ $t('tree. replaceExcel') }}
              </button>
              <input
                ref="fileInput"
                type="file"
                accept=".xls,.xlsx"
                hidden
                @change="handleFileChange"
              >
            </div>
            <div v-if="file" class="file">
              <div>
                <div class="file_info">
                  <span>{{ file.name }}</span>  <span>{{ fileSize }}KB </span>
                </div>
                <p>{{ $t('tree. uploadTime') }}: {{ uploadTime }}</p>
              </div>
              <div v-if="uploadSuccess">
                <img src="@/assets/img/icon/duigou.png" alt="">
              </div>
            </div>
          </div>
          <div class="button_container">
            <button @click="ensureUpload">
              {{ $t('limite.ok') }}
            </button>
            <button @click="cancelDialog">  
              {{ $t('limite.cancel') }}
            </button>
          </div>
        </div>
      </div>
    </OpDialog>
  </div>
</template>
<!-- eslint-disable no-lonely-if -->
<script>
import OpDialog from '@/components/common/OpDialog.vue'
import OppleModal from '@/components/OppleModal/index.vue'
import vuescroll from 'vuescroll'
import SortSelect from '@/components/select/SortSelect'
import { getEditContent, getDefaultContent } from './tree.utils.js'
import {
  FindUserAreaTree,
  Create,
  Edit,
  DeleteArea,
  FindArea,
  UpdateAreaSort,
  GetAreaExcel,
  ExcelCreateArea,
  SetAreaSort
} from '@/axios/IArea'
import {
  UpdateRoomName,
} from "@/axios/IDesign";
import { alerterror, alertsuccess, warning } from '@/assets/js/common.js'
import eventBus from '@/utils/eventBus'
import i18n from '@/i18n/i18n';
import { isExistPermission } from '@/components/OppleAuth/index';
import { getSortType } from '@utils/utils'
import { debounce } from "@utils/utils";

function calculateOffsetTopBetweenNodes(startNode, endNode, maxSteps = 50) {
    if (!startNode || !endNode || maxSteps <= 0) {
        return 0; // 参数无效时返回0
    }
    
    let currentNode = startNode;
    let totalOffsetTop = 0;
    let steps = 0;

    while (currentNode && currentNode !== endNode && steps < maxSteps) {
        totalOffsetTop += currentNode.offsetTop || 0; // 累加当前节点的offsetTop
        currentNode = currentNode.offsetParent; // 移动到父节点
        steps++;
    }

    // 如果未找到目标节点，或者超过最大步数，则返回0
    if (currentNode !== endNode) {
        return 0;
    }

    return totalOffsetTop;
}

export default {
  name: 'LyTree',
  // 高亮选中的节点id 是否是管理员 1-设备 2-场景 3-自动化  默认是设备 节点是否显示数量 是否显示无区域(仅对type=1生效) isall解决从新增设备页面返回 只查询子节点结果的问题跟权限问题 isrefresh解决点击子节点刷新的内容只有子节点下的问题 true隐藏title
  components: {
    vuescroll,
    OpDialog,
    OppleModal,
    SortSelect
  },
  props: [
    'showSort',
    'firstNode', // 自动高亮第一个节点
    'gpno', //高亮选中的节点id
    'is_superuser', //是否是管理员
    'areaTreeType',//1-设备 2-场景 3-自动化 
    'executeType',//默认是设备
    'exendProtocolTypes',//节点是否显示数量
    'showcount', //节点上的数量设备数、场景数、自动化数
    'displaynoarea',//是否显示无区域(仅对type=1生效)
    'isall',// isall解决从新增设备页面返回
    'isrefresh',//只查询子节点结果的问题跟权限问题
    'onlynoarea',
    'is_switch',
    'sideflex',
    'treeMenuHide',
    'limitLevel',
    'postFunParam',
    'isTitleShow', 
    'visualTreeType',//1-地图画布列表 2-地图画布绑定区域
    'checkedAreaIds',//地图绑定区域已绑定区域
    'configNameList', //区组号别名
    'allConfigNameList', //所有区组号别名
    'isSetConfig', //是否设置区组号别名
    'isMap', // 是否地图
    'draggable',
    'default-tree-level',
    'defaultHlightAll',
    'isPermissionDenied' //是否提示权限不足
  ],
  data () {
    return {
      isLoadingCreate: false,
      sortType: '',
      allcount: 0, // 设备数量
      isloading: true, // 是否显示加载中
      treeData: [
        {
          id: -1,
          name: this.$t('tree.city'),
          level: -1,
          child: []
        }
      ], // 树形数据
      filterText: '', // 搜索框输入值
      isEdit: false, // 是否可编辑
      edit_name: '', // 编辑的名称
      /** 重命名区域提交中：用于失败时回滚树节点文案并保持编辑态 */
      pendingAreaRename: null,
      defaultProps: {
        children: 'child',
        label: 'name'
      }, // 树形控件 改变默认关键字
      select_id: null, // 树形id
      select_level: null, // 树形层级
      select_node: null, // 树形节点
      delDialogVisible: false, // 删除确认弹窗
      issuper: false, // 是否超级 用户 控制是否可操作
      AddArea: false, // 新增权限
      UpdateArea: false, // 修改权限
      DeleteArea: false, // 删除权限
      switchYes:
        // '<div style="width:100%;height:100%;background-position: 50%;background-image: url(/static/img/checkboxYes.png);background-repeat: no-repeat;"></div>',
        `<div style="width:100%;height:100%;background-position: 50%;background-image: url(${require('@static/img/checkboxYes.png')});background-repeat: no-repeat;"></div>`,
      switchNo:
        `<div style="width:100%;height:100%;background-position: 50%;background-image: url(${require('@static/img/checkboxNo.png')});background-repeat: no-repeat;"></div>`,
      is_refresh: false, // 刷新状态
      refreshTime: null, // 刷新超时器
      refreshTimeLimit: 3000, // 刷新超时器-定时10秒
      activeObject: null,
      isFirstRender: true,
      isLoadingSort: false,
      uploadAreaTreeExcelDialogVisible: false,
      file: null,
      uploadTime: null,
      uploadSuccess: false,
      currentLevel: null,
      expandedKeys: [],
      pendingSelectGpNo: null
    }
  },
  computed: {
    fileSize() {
      return this.file ? (this.file.size / 1024).toFixed(2) : 0;
    },

    minLevel() {
      const ShowStatus = JSON.parse(getLocalStoragItem('projectinfor')).ShowStatus;

      if (ShowStatus === 2) return 2;

      return 4;
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree2.filter(val)
    }
  },
  created () {
    // 页面初始化
    this.issuper = this.is_superuser
    // 画布更新tree
    eventBus.$on('refresh', this.refresh)
    if (this.isall) {
      // 说明页面在区域管理 重新检查权限
      if (
        this.$store.state.userInfor.UserRole ==
        this.$store.state.userRole[0].rolevalue ||
        this.$store.state.userInfor.UserRole ==
        this.$store.state.userRole[1].rolevalue
      ) {
        this.issuper = true
      }
    }
  },
  mounted () {
    // 刷新树形控件 同时检查权限
    this.refresh()

    if (Number.isInteger(this.defaultTreeLevel)) {
      this.currentLevel = this.defaultTreeLevel
    }

    this.AddArea = isExistPermission('AddArea')
    this.UpdateArea = isExistPermission('UpdateArea')
    this.DeleteArea = isExistPermission('DeleteArea')
  },
  beforeDestroy () {
    eventBus.$off('refresh', this.refresh)

    if (this.refreshTime != null) {
      clearTimeout(this.refreshTime)
      this.refreshTime = null
    }

    const tree = this.$refs.tree2
    if (tree) {
      tree.$off && tree.$off()
    }

    this.treeData = []
  },
  methods: {
    async sortChangeHandler (v) {
      if (this.gpno === -1) {
        return;
      }

      this.filterText = '';
      this.sortType = v;

      try {
        await SetAreaSort({
          GpNo: this.gpno,
          SortType: v
        });
      } catch (e) {
        console.log(e);
      }
      
      this.refresh();
    },
    async downloadExcelTemplate(){
      try {
        const res = await GetAreaExcel()
        // 假设接口返回的 URL 在 data.Result.ExcelUrl 中
        const excelUrl = res.Result.ExcelUrl;
        // 创建一个临时链接元素并模拟点击下载
        const a = document.createElement('a');
        a.href = excelUrl;
        a.download = excelUrl.split('/').pop(); // 以链接中的文件名作为下载文件名
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (error) {
        console.error('下载失败:', error);
      }
      
    },
    cancelDialog () {
      this.uploadAreaTreeExcelDialogVisible = false;
      this.$store.commit('visual/setTreeMenuShow')
    },
    functionExcelCreateArea(){},
    async ensureUpload(){
      // 创建 FormData 对象
      const formData = new FormData();
      formData.append('formFile', this.file); 
      const res = await ExcelCreateArea(formData,this.functionExcelCreateArea,{
        'Accept': 'text/plain',
        'Content-Type': 'multipart/form-data'
      })
     
      if (res.StatusCode === this.$store.state.rightStatusCode) {
        this.uploadSuccess = true;
        alertsuccess(this, res.StatusCode);
        this.doFindUserAreaTree();
        this.$emit('uploadSuccess');
        setTimeout(() => {
          this.uploadAreaTreeExcelDialogVisible = false;
          this.uploadSuccess = false;
        }, 1000);
      } else {
        alerterror(this, res.StatusCode);
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      this.processFile(file);
    },
    handleDropFile(event) {
      event.preventDefault(); // 阻止默认行为（防止浏览器下载文件）
      event.stopPropagation(); // 阻止事件冒泡

      const file = event.dataTransfer.files[0];
      this.processFile(file);
    },
    processFile(file) {
      if (file && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls'))) {
        this.file = file;
        console.log("this.file: ",this.file)
        this.uploadTime = new Date().toLocaleString();
      } else {
        this.$message.warning(
          this.$t('tree.uploadType')
        );
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      let isAllowInner = ['prev', 'next'].includes(type);

      if (navigator.userAgent.includes('Windows')) {
        // isAllowInner = true;
      }

      // console.log('type', type);
      // return draggingNode.parent?.data?.id === dropNode.parent?.data?.id && (['prev', 'next'].includes(type)) && dropNode.data.id !== 0;
      return draggingNode.parent?.data?.id === dropNode.parent?.data?.id && isAllowInner && dropNode.data.id !== 0;
    },

    allowDrag(draggingNode) {
      if (!isExistPermission('UpdateArea')) return false;
      if (this.isLoadingSort || [0, -1].includes(draggingNode.data.id)) return false;

      //修改名字状态下,禁止拖动
      if(this.isEdit === true && this.isSelect(draggingNode?.data)) return false
      // console.log('parentGpNo', draggingNode);
      
      return true
    },
    handleDragStart(node, event) {
      const draggingNode = event.target;
      
      // 获取到拖拽指示元素 (通过事件对象找到当前拖拽的 DOM 元素)
      const dragIndicator = event.dataTransfer;

      // 这里可以直接修改拖拽示意元素的样式
      if (dragIndicator) {
        const child = draggingNode.children[0] ? draggingNode.children[0] : draggingNode;
        dragIndicator.setDragImage(child, 0, -20); // 修改拖拽示意图像
      }

      // setTimeout(() => {
      //   // 获取拖拽的半透明示意节点
      //   const dragElement = document.querySelector('.el-tree-node--dragging');
        
      //   if (dragElement) {
      //     // 修改拖拽示意元素的高度
      //     dragElement.style.height = '50px';  // 你可以根据需要调整高度
      //     dragElement.style.opacity = '0.7';  // 你还可以修改其他样式，如透明度
      //   }
      // }, 0);
    },
    handleDragEnter() {

    },
    handleDragLeave() {

    },
  
    handleDragOver(node1, node2, e) {
      e.preventDefault()

      if (navigator.userAgent.includes('Windows')) {
        e.dataTransfer.dropEffect = 'move';
      }
    },

    handleDragEnd() {

    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      // debugger
      const curNodeId = draggingNode.data?.id;
      const replaceNodeId = dropNode.data?.id
      const siblingNodes = dropNode.parent.childNodes;
      const curNodeIndex = siblingNodes.findIndex(item => item.data?.id === curNodeId);
      const replaceNodeIndex = siblingNodes.findIndex(item => item.data?.id === replaceNodeId);
      // debugger
      // const curNodeIndex = siblingNodes.findIndex(item => item.id === curNodeId);
      // const forwardNode = siblingNodes[curNodeIndex - 1];

      // if (!forwardNode) return;

      const newSiblingNodes = siblingNodes.map((item, i) => {
        if (i === curNodeIndex) {
          return {
            GpNo: replaceNodeId,
            sort: replaceNodeIndex
          }
        }

        if (i === replaceNodeIndex) {
          return {
            GpNo: curNodeId,
            sort: curNodeIndex
          }
        }

        return {
          GpNo: item.data?.id,
          sort: i
        }
      });

      this.requestUpdateAreaSort(newSiblingNodes);
    },
    rowTop(curNode) {
      const curNodeId = curNode.id;
      const siblingNodes = curNode.parent.childNodes;
      const curNodeIndex = siblingNodes.findIndex(item => item.id === curNodeId);
      // const forwardNode = siblingNodes[curNodeIndex - 1];

      if (curNodeIndex === 0) return;

      const newSiblingNodes = siblingNodes.map((item, i) => {
        if (i === curNodeIndex) {
          return {
            GpNo: item.data.id,
            sort: 0
          }
        }

        return {
          GpNo: item.data.id,
          sort: i + 1
        }
      });

      this.requestUpdateAreaSort(newSiblingNodes);
    },

    rowUp(curNode) {
      const curNodeId = curNode.id;
      const siblingNodes = curNode.parent.childNodes;
      const curNodeIndex = siblingNodes.findIndex(item => item.id === curNodeId);
      const forwardNode = siblingNodes[curNodeIndex - 1];

      if (!forwardNode) return;

      const newSiblingNodes = siblingNodes.map((item, i) => {
        if (i === curNodeIndex) {
          return {
            GpNo: item.data.id,
            sort: curNodeIndex - 1
          }
        }

        if (i === curNodeIndex - 1) {
          return {
            GpNo: item.data.id,
            sort: curNodeIndex
          }
        }

        return {
          GpNo: item.data.id,
          sort: i
        }
      });

      this.requestUpdateAreaSort(newSiblingNodes);
    },

    rowDown(curNode) {
      const curNodeId = curNode.id;
      const siblingNodes = curNode.parent.childNodes;
      const curNodeIndex = siblingNodes.findIndex(item => item.id === curNodeId);
      const nextNode = siblingNodes[curNodeIndex + 1];

      if (!nextNode) return;

      const newSiblingNodes = siblingNodes.map((item, i) => {
        if (i === curNodeIndex) {
          return {
            GpNo: item.data.id,
            sort: curNodeIndex + 1
          }
        }

        if (i === curNodeIndex + 1) {
          return {
            GpNo: item.data.id,
            sort: curNodeIndex
          }
        }

        return {
          GpNo: item.data.id,
          sort: i
        }
      });

      console.log('siblingNodes', curNode, siblingNodes, newSiblingNodes);

      this.requestUpdateAreaSort(newSiblingNodes);

      // if (nextNode) {
      //   console.log('交换', curNode.data.name, nextNode.data.name, siblingNodes);
      // }
      // console.log('node, data, e', node);
    },
    scrollToHighGpno() {
      if (!this.isFirstRender) return;
      const highGpNoItem = document.querySelector('.el-tree-node.is-current');
      // debugger
      if (highGpNoItem) {
        const top = calculateOffsetTopBetweenNodes(highGpNoItem, this.$refs.lyTreeContainer.children[0]);

        if (top > 250) this.$refs.lyTreeContainer.scrollTop = top - 100;
      }

      this.isFirstRender = false;
    },
    sideflexEvent () {
      this.$emit('sideflexEvent')
    },
    /* 点击树节点 返回对应数据给调用组件的窗口
     * data：该节点所对应的对象
     * node：节点对应的Node
     * e：节点组件本身
     */
    handleNode (data, node, e) {
      if (this.isPermissionDenied && this.$store.state.isNoLimit && data.LoadData === false) {
        warning(this, this.$t('tree.nopermission'))
      }
      if (
        this.limitLevel != null &&
        this.limitLevel.indexOf(data.level) != -1
      ) {
        return
      }
      let _event = event || window.event
      _event = _event && _event.target
      if (
        _event != null &&
        _event.type == 'button' &&
        _event.name == 'switch'
      ) {
        _event = null
        return
      }
      _event = null
      // console.log(this.$route.name);
      // data(该节点所对应的对象) node(节点对应的Node)  e(节点组件本身)
      this.highlightlocal(data)
      this.$emit('treeClick', [data, node])
    },
    /* 解决页面刷新选择的节点丢失高亮丢失
     * model：节点对象
     */
    highlightlocal (model) {
      // map绑定区域不覆盖节点高亮
      if (this.visualTreeType === 2) {
        return
      }
      this.currentLevel = model.level;
      setLocalStoragItem('highid', model.id)
      setLocalStoragItem('treelevel', model.level)
    },
    /* 搜素树形的方法
     * value：搜索关键字
     * treeData：树数据
     */
    filterNode (value, treeData) {
      if (!value) return true
      console.log('treeData', treeData);
      
      return (treeData.allName || '').includes(value);
    },
    refreshStop () {
      this.is_refresh = false
    },
    refreshStart (isStart) {
      this.is_refresh = isStart
      if (isStart == true) {
        if (this.refreshTime != null) {
          clearTimeout(this.refreshTime)
        }
        this.refreshTime = setTimeout(this.refreshStop, this.refreshTimeLimit)
      } else {
        if (this.refreshTime != null) {
          clearTimeout(this.refreshTime)
        }
      }
    },

    /* 刷新树
     */
    refresh () {
      this.refreshStart(true)
      // 刷新页面

      this.doFindUserAreaTree()
    },
    /* 查询接口返回的原始数据包 根据不同的接口显示不同的数据 区分 区域 场景 自动化 并生成树
     * rs:原始数据包
     */
    functionDoFindArea (rs) {
      this.refreshStart(true)
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          this.treeData = [
            {
              id: rs.Result.Gpno,
              level: rs.Result.Level,
              child: []
            }
          ]
          if (this.showcount) {
            if (this.areaTreeType == 2) {
              this.treeData[0].name =
                rs.Result.GpName + '(' + rs.Result.SceneCount + ')'
            } else if (this.areaTreeType == 3) {
              this.treeData[0].name =
                rs.Result.GpName + '(' + rs.Result.IFtttCount + ')'
            } else {
              this.treeData[0].name =
                rs.Result.GpName + '(' + rs.Result.DeviceCount + ')' // 202004/03
              // this.treeData[0].name=rs.Result.GpName+"("+rs.Result.DeviceCount+")"+'_'+rs.Result.Gpno;
            }
          } else {
            this.treeData[0].name = rs.Result.GpName
          }

          this.$store.dispatch('updateGpName', {
            Gpno: rs.Result.Gpno,
            GpName: rs.Result.GpName,
            Level: rs.Result.Level,
            LoadData: rs.Result.LoadData
          })
          
          if (rs.Result.Childs.length > 0) {
            rs.Result.Childs.forEach((item, index) => {
              // console.log('rs.Result', rs.Result, item)
              this.addArry({
                ...item, 
                isShowUp: index !== 0,
                isShowDown: item.Level === 1 ? index !== rs.Result.Childs.length - 2 : index !== rs.Result.Childs.length - 1,
                // parentGpNo: rs.Result.Gpno
              }, this.treeData[0].child)
            })
          }
        }
      }
      this.$nextTick(this.functionSetDefault)
      this.isloading = false
    },
    /* 查询用户区域接口返回的原始数据包 并生成树
     * rs:原始数据包
     */
    functionDoFindUserAreaTree (rs) {
      this.isloading = false
      // this.refreshStart(false);
      // var _item = null;
      this.treeData = [
        {
          id: -1,
          // name: this.$t('tree.city'),
          name: i18n.t('tree.city'),
          level: -1,
          child: [],
          AddArea: this.AddArea,
          UpdateArea: this.UpdateArea,
          DeleteArea: this.DeleteArea
        }
      ]
      
      // if (this.visualTreeType === 2) {
      //   this.treeData[0].disabled = true
      // }

      let firstNode = null;

      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.allcount = 0
        if (rs.Result != null) {
          this.$store.dispatch('updateGpName', {
            Gpno: rs.Result.Gpno,
            GpName: rs.Result.GpName,
            Level: rs.Result.Level
          })
          if (rs.Result.length > 0) {
            rs.Result.forEach((item, index) => {
              if (this.firstNode && firstNode === null && item.Gpno !== 0) {
                firstNode = item;
              };

              this.addArry({
                ...item, 
                isShowUp: index !== 0,
                isShowDown: item.Level === 1 ? index !== rs.Result.length - 2 : index !== rs.Result.length - 1,
                // parentGpNo: rs.Result.Gpno
              }, this.treeData[0].child)

              this.$store.dispatch('updateGpName', {
                Gpno: item.Gpno,
                GpName: item.GpName,
                Level: item.Level,
                LoadData: item.LoadData,
              })
            })
          }
        }
      }

      this.$nextTick(() => {
        if (this.pendingSelectGpNo != null) {
          this.applyPendingSelectGpNo()
        } else {
          this.functionSetDefault()
        }
      })

      if (firstNode) {
        this.$emit('treeClick', [{
          id: firstNode.Gpno,
          name: firstNode.GpName
        }, {}])
      }

      console.log('treeData', this.treeData)
    },
    setGpNo(gpno) {
      try {
        this.$refs.tree2.setCurrentKey(gpno)
      } catch (error) {

      }
    },
    applyPendingSelectGpNo () {
      const gpno = this.pendingSelectGpNo
      if (gpno == null) {
        return
      }
      this.pendingSelectGpNo = null
      this.$nextTick(() => {
        this.setGpNo(gpno)
        this.$nextTick(() => {
          try {
            const treeNode = this.$refs.tree2.getNode(gpno)
            if (treeNode) {
              this.highlightlocal(treeNode.data)
              this.$emit('treeClick', [treeNode.data, treeNode])
            }
          } catch (error) {

          }
          this.$emit('editorreload')
        })
      })
    },
    /* 设置树节点默认高亮
     */
    functionSetDefault () {
      const gpno = this.gpno
      if (gpno == null || gpno < 0) {
        return
      }
      const restoreHighlight = () => {
        try {
          this.$refs.tree2.setCurrentKey(gpno)
        } catch (error) {

        }
      }
      this.$nextTick(() => {
        restoreHighlight()
        this.$nextTick(() => {
          restoreHighlight()
          this.scrollToHighGpno();
        })
      })
      if (this.is_switch && this.visualTreeType !== 1) {

        if(this.defaultHlightAll){
          //获取所有节点并全部勾选
          this.$nextTick(() => {
            // 获取所有节点的 key
            const allKeys = this.getAllNodeKeys(this.treeData);
            this.$refs.tree2.setCheckedKeys(allKeys);
            this.$emit('getCheckedKeys', this.$refs.tree2.getCheckedKeys())
          });
        }

        if(gpno){
        this.$refs.tree2.setCheckedKeys([gpno])
        this.$emit('getCheckedKeys', this.$refs.tree2.getCheckedKeys())
      }
      }
    },
    getAllNodeKeys(data) {
      let keys = [];
      data.forEach(item => {
        keys.push(item.id);
        if (item.child && item.child.length > 0) {
          keys = keys.concat(this.getAllNodeKeys(item.child));
        }
      });
      return keys;
    },
    /* 查询用户区域 根据不同的参数有不同的查询接口 区分 区域 场景 自动化
     */
    doFindUserAreaTree () {
      this.isloading = true
      let para = { areaTreeType: this.areaTreeType }
      if (this.postFunParam != null) {
        para = this.extend(para, this.postFunParam)
      }
      if (this.areaTreeType == 1 && this.executeType != null) {
        para.executeType = this.executeType
      }
      if (this.areaTreeType == 1 && this.exendProtocolTypes != null) {
        para.exendProtocolTypes = this.exendProtocolTypes
      }
      if (this.gpno < 0 || this.issuper || this.isrefresh) {
        FindUserAreaTree(para, this.functionDoFindUserAreaTree)
      } else {
        if (this.onlynoarea) {
          FindUserAreaTree(para, this.functionDoFindUserAreaTree)
        } else {
          para.gpNo = this.gpno
          if (this.areaTreeType) {
            para.areaTreeType = this.areaTreeType
          }
          FindArea(para, this.functionDoFindArea)
        }
      }

      para = null
    },
    /* 通过接口获取到的数据放入区域树model 当前对象 fmodel父对象
     */
    addArry (model, fmodel, parNodeList) {
      // 画布列表隐藏4级目录
      if (model.Level === 4 && this.visualTreeType === 1) {
        return
      };

      const curParNodeList = model.Level === 1 ? [] : parNodeList;
      // console.log('curParNodeList', model, fmodel);

      this.$store.dispatch('updateGpName', {
        Gpno: model.Gpno,
        GpName: model.GpName,
        Level: model.Level,
        LoadData: model.LoadData,
      })
      const tempmodel = {}
      tempmodel.id = model.Gpno
      tempmodel.name = model.GpName
      tempmodel.Path = model.Path
      tempmodel.index = model.index
      tempmodel.isShowUp = model.isShowUp
      tempmodel.isShowDown = model.isShowDown
      // 无区域(id=0)的LoadData强制设置为true
      tempmodel.LoadData = model.Gpno === 0 ? true : model.LoadData;
      // tempmodel.parentGpNo = model.parentGpNo

      // 记录父节点id
      tempmodel.parentNodes = model.ParentNodes || []
      if (this.showcount) {
        if (this.areaTreeType == 1) {
          if (!(this.displaynoarea && tempmodel.id == 0)) {
            if (model.Level == 1) {
              this.allcount = this.allcount + model.DeviceCount
            }
          }

          // // tempmodel.name = model.GpName + '(' + model.DeviceCount + ')'+'_'+model.Gpno;
          // tempmodel.name = model.GpName + '(' + model.DeviceCount + ')';//202004/03
          tempmodel.count = model.DeviceCount
        } else if (this.areaTreeType == 2) {
          this.allcount = this.allcount + model.SceneCount
          // tempmodel.name = model.GpName + '(' + model.SceneCount + ')';
          tempmodel.count = model.SceneCount
        } else if (this.areaTreeType == 3) {
          this.allcount = this.allcount + model.IFtttCount
          // tempmodel.name = model.GpName + '(' + model.IFtttCount + ')';
          tempmodel.count = model.IFtttCount
        }
      } else {
        if (this.areaTreeType == 1) {
          if (!(this.displaynoarea && tempmodel.id == 0)) {
            this.allcount = this.allcount + model.DeviceCount
          }
        } else if (this.areaTreeType == 2) {
          this.allcount = this.allcount + model.SceneCount
        } else if (this.areaTreeType == 3) {
          this.allcount = this.allcount + model.IFtttCount
        }

        // tempmodel.name = model.GpName;
      }

      tempmodel.IsLeaf = model.IsLeaf
      tempmodel.xname = model.GpName // 显示区域名称
      tempmodel.level = model.Level
      tempmodel.AddArea = this.AddArea
      tempmodel.UpdateArea = this.UpdateArea
      tempmodel.DeleteArea = this.DeleteArea
      tempmodel.allName = (curParNodeList && curParNodeList.length ? curParNodeList.join(',') + ',' : '') + model.GpName;
      // model.allName = (curParNodeList.length ? curParNodeList.join(',') + ',' : '') + model.GpName;
      // console.log('model model', model);
      if(this.isSetConfig){
        const configData = this.allConfigNameList.find(item => {
          return item.GpNo === tempmodel.id
        })
        tempmodel.AreaNo = Number.isInteger(configData?.AreaNo) ? configData?.AreaNo : '' //区号映射别名
        tempmodel.ClusterNo = Number.isInteger(configData?.ClusterNo) ? configData?.ClusterNo : '' //组号映射别名
        tempmodel.configName = tempmodel.level === 3 ? tempmodel.AreaNo : tempmodel.ClusterNo
        if(tempmodel.level === 3){
          tempmodel.isRepeatAreaNo = this.allConfigNameList.some(item => item.AreaNo == tempmodel.AreaNo && item.GpNo !== tempmodel.id && item.Type === 'Area')
        }
      }
      // if (this.visualTreeType === 2 && model.Level < 4) {
      //   tempmodel.disabled = true
      // } else {
      //   tempmodel.disabled = false
      // }
      if (!this.onlynoarea) {
        if (model.Childs) {
          if (model.Childs.length > 0) {
            tempmodel.child = []
            model.Childs.forEach((item, index) => {
              this.addArry({
                ...item, 
                isShowUp: index !== 0,
                isShowDown: item.Level === 1 ? index !== model.Childs.length - 2 : index !== model.Childs.length - 1,
                // parentGpNo: model.Gpno
              }, tempmodel.child, [...(curParNodeList || []), model.GpName])
            })
          }
        }

        if (!(this.areaTreeType != 1 && tempmodel.id == 0)) {
          if (
            !(this.displaynoarea && this.areaTreeType == 1 && tempmodel.id == 0)
          ) {
            fmodel.push(tempmodel)
          }
        }
      } else {
        if (tempmodel.id == 0) {
          fmodel.push(tempmodel)
        }
      }

      tempmodel.countTotal = tempmodel.count
      // if(this.areaTreeType == 1){tempmodel.countTotal = tempmodel.count;}
      // else{tempmodel.countTotal = tempmodel.count + this.totalChildCount(tempmodel['child']);}
    },
    uploadAreaTreeExcel(){
      this.$store.commit('visual/setTreeMenuShow')
      this.uploadAreaTreeExcelDialogVisible = true
      this.file = null
      this.$refs.fileInput.value = ''
    },
    hideDialog(){
      this.uploadAreaTreeExcelDialogVisible = false
      this.$store.commit('visual/setTreeMenuShow')
    },
    append (node, data, e) {
      if (e) {
        e.stopPropagation()
      }
      if (!this.isEdit) {
        this.$refs.tree2.store.nodesMap[data.id].expanded = true

        this.select_id = data.id
        this.edit_name = ''
        const newChild = {
          name: '',
          level: data.level + 1,
          isEdit: true
        }
        this.isEdit = true
        if (!data.child) {
          this.$set(data, 'child', [])
        }
        data.child.unshift(newChild)
      } else {
        warning(this, this.$t('tree.updatewaring'))
      }
    },

    async requestUpdateAreaSort(list) {
      this.isLoadingSort = true
      try {
        const res = await UpdateAreaSort(list);

        if (res.StatusCode !== this.$store.state.rightStatusCode) return;

        this.doFindUserAreaTree();
      } catch (error) {
        console.log('error', error);
      } finally {
        this.isLoadingSort = false
      }
    },

    remove (node, data, e) {
      if (e) {
        e.stopPropagation()
      }
      if (this.isEdit) {
        warning(this, this.$t('tree.updatewaring'))
        return
      }
      this.select_node = node
      this.delDialogVisible = true
    },
    switch (node, data, e) {
      node.data.switch = !node.data.switch
      if (node.data.switch == true) {
        e.currentTarget.innerHTML = this.switchYes
      } else {
        e.currentTarget.innerHTML = this.switchNo
      }
      e = event || window.event
      // e.stopPropagation();
      // console.log(this.$route.name);
      // data(该节点所对应的对象) node(节点对应的Node)  e(节点组件本身)
      this.highlightlocal(data)
      this.$emit('switchClick', [data, node, e, node.data.switch])
    },
    /* 勾选树区域
     */
    handleCheck (data, checked, indeterminate) {
      // var d = this.$refs.tree2.getCheckedKeys();
      let node = this.$refs.tree2.getCurrentNode()
      this.highlightlocal(data)
      this.$emit('switchClick', [data, node, null, data.checked, checked])
      node = null
    },
    /* 勾选树区域
     */
    handleCheckChange (data, checked, indeterminate) {
      data.checked = checked
      data.switch = checked
    },
    /* 删除区域接口返回的原始数据处理
     * rs:接口返回的原始数据包
     */
    functionDoDeleteArea (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, this.$store.state.rightStatusCode)
        this.doFindUserAreaTree()
        this.$emit('onDelete', this.select_node.data.id)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    getCheckedKeys () {
      return this.$refs.tree2.getCheckedKeys()
    },

    // doDeleteArea(params) {
    // 	var para = { gpNo: params.id };
    // 	DeleteArea(para, this.functionDoDeleteArea);
    // 	para = null;
    // },
    /* 执行删除区域
     */
    delSelect () {
      let para = {
        gpNo: this.select_node.data.id
      }
      DeleteArea(para, this.functionDoDeleteArea)
      this.delDialogVisible = false
      // alertsuccess(this, this.$store.state.rightStatusCode);
      para = null
    },
    delTree (data, payload) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === payload.id) {
          data.splice(i, 1)
          break
        }
        if (data[i].child && data[i].child.length) {
          this.delTree(data[i].child, payload)
        }
      }
    },
    /* 点击出现输入框
     */
    update (node, data, e) {
      if (e) {
        e.stopPropagation()
      }
      if (this.isEdit) {
        warning(this, this.$t('tree.updatewaring'))
        return
      }
      this.select_id = data.id
      this.select_level = data.level
      this.edit_name = data.xname
      this.isEdit = true
    },
    /* 新增区域 接口返回的数据处理 刷新树
     * rs:接口返回的原始数据包
     */
    functionDoCreate (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        // 刷新页面
        alertsuccess(this, rs.StatusCode)
        this.doFindUserAreaTree()
      } else {
        this.pendingSelectGpNo = null
        alerterror(this, rs.StatusCode)
      }

      this.isLoadingCreate = false;
    },
    /* 创建区域
     */
    doCreate: debounce(function (params) {
      if (this.isLoadingCreate) return;

      this.isLoadingCreate = true;
      this.pendingSelectGpNo = params.id

      let para = { ParentGpNo: params.id, GpName: params.name }
      Create(para, this.functionDoCreate)
      para = null
    }),
    editMsg (data, node, e) {
      if (e) {
        e.stopPropagation()
      }
      if (this.edit_name.replace(/^\s+|\s+$/g, '')) {
        const virtualNode = node.parent // 父节点 virtualNode.data.id为-1表示添加城市
        if (!data.id) {
          // 新增
          let params = {
            name: this.edit_name,
            id: virtualNode.data.id != -1 ? virtualNode.data.id : 0
          }
          this.isEdit = false
          this.select_id = null
          this.select_level = null
          this.doCreate(params)
          params = null
        } else {
          let params = {
            name: this.edit_name,
            id: data.id
          }
          this.pendingAreaRename = {
            gpNo: data.id,
            oldName: data.xname != null && data.xname !== '' ? data.xname : data.name
          }
          this.doEdit(params)
          // 等 Edit 成功后再关编辑态、更新树；失败则保持 isEdit 与输入框
          params = null
        }
      }
    },
    /* 编辑区域 接口返回数据后处理
     * rs：接口返回的原始数据包
     */
    functionDoEdit (rs, param) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        try {
          const {GpNo,GpName} = param
          UpdateRoomName([{
            GpNo:GpNo,
            RoomName:GpName
          }],(rs) =>{
            this.$emit('updateName', param);
          })
        } catch (error) {

        }
        this.editorTree(this.treeData, { name: param.GpName, id: param.GpNo })
        this.edit_name = param.GpName
        this.isEdit = false
        this.select_id = null
        this.select_level = null
        this.pendingAreaRename = null
        // 刷新页面
        this.$emit('editorreload')
        alertsuccess(this, rs.StatusCode)
      } else {
        if (this.pendingAreaRename && this.pendingAreaRename.gpNo === param.GpNo) {
          this.editorTree(this.treeData, {
            name: this.pendingAreaRename.oldName,
            id: param.GpNo
          })
        }
        this.pendingAreaRename = null
        alerterror(this, rs.StatusCode)
        this.$nextTick(() => {
          const root = this.$el
          if (!root) return
          const inp = root.querySelector('.custom-tree-container input.ly-edit__text') ||
            root.querySelector('input.ly-edit__text')
          if (inp && typeof inp.focus === 'function') {
            inp.focus()
          }
        })
      }
    },
    /* 编辑区域
     * params：需要的参数对象
     */
    doEdit (params) {
      let para = { GpNo: params.id, GpName: params.name }
      Edit(para, this.functionDoEdit)
      para = null
    },
    editorTree (data, payload) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === payload.id) {
          data[i].name = payload.name // +'('+data[i].count+')';
          data[i].xname = payload.name
          break
        }
        if (data[i].child && data[i].child.length) {
          this.editorTree(data[i].child, payload)
        }
      }
    },
    close (data, node, e) {
      if (e) {
        e.stopPropagation()
      }
      if (!data.id) {
        node.parent.data.child.forEach((item, i) => {
          if (!item.id && item.id != 0) {
            node.parent.data.child.splice(i, 1)
          }
        })
      }
      this.select_id = null
      this.select_level = null
      this.edit_name = data.xname
      this.isEdit = false
    },
    nameChange (event, data, node) {
      if (!event || !data) return;
  
      // e = event || window.event
      event && event.stopPropagation()
      this.edit_name = event.target.value;

      if (event?.key === 'Enter') {
        this.editMsg(data, node);
      }
    },

    isSelect (data) {
      return data.id === this.select_id && data.level === this.select_level
    },
    mapCheckboxSameId (area) {
      return this.treeDataCheckId === area.id
    },
    configNameChange (e, data, node) {
      const value = e.target.value

      node.data.isRepeatAreaNo = false; // 默认设置为 false
      if(data.level === 3){//区号判断重复
        const isRepeat = this.allConfigNameList.some(item => item.AreaNo == value && item.GpNo !== data.id && item.Type == 'Area');
        if(isRepeat){//区号重复了，不是本区域的区号
          node.data.isRepeatAreaNo = true
        }
      }
      this.$emit('changeConfigName', {value, data, node})
      // 如果区号重复，再次触发 changeConfigName 事件
      if (node.data.isRepeatAreaNo) {
        this.$nextTick(() => {
          this.$emit('changeConfigName', {value, data, node})
        });
      }
    },
    renderContent (h, { node, data }) {
      // return 123454
      // visual地图返回默认
      if (this.visualTreeType === 1) {
        return (
          <div
            style={
              'width: 100%;padding-left: 24px;box-sizing: border-box;' +
              (this.is_switch ? 'width: calc( 100% - 50px );' : '')
            }
          >
            <span class="ly-tree-node" title={node.label}>{node.label}</span>
          </div>
        )
      }
      // visual地图-绑定区域设置返回checkbox
      if (this.visualTreeType === 2) {
        const isFloorHasChild = node.level ==1
        const isCheckedIndex = this.checkedAreaIds.findIndex(
          (value) => value.gpNo === data.id
        )
        let isGrayCheck = false
        if (this.activeObject) {
          if (
            this.activeObject.gpNo !== undefined &&
            data.id === this.activeObject.gpNo
          ) {
            isGrayCheck = false
          } else {
            isGrayCheck = true
          }
        } else {
          isGrayCheck = true
        }
        return (
          <div
            style={
              'width: 100%;padding-left: 24px;box-sizing: border-box;' +
              (this.is_switch ? 'width: calc( 100% - 50px );' : '')
            }
          >
            <span class={!isGrayCheck ? 'ly-tree-node ' : 'ly-tree-node gray'} title={node.label}>
              <span style={'max-width:106px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'} > {node.label} </span>
              <span
                style={!isFloorHasChild ? 'display:block' : 'display:none'}
                class={
                  isCheckedIndex !== -1
                    ? 'el-icon-check check-icon'
                    : 'el-icon-check white-icon'
                }
              ></span>
            </span>
          </div>
        )
      }
      //保利项目-区组号映射
      if(this.isSetConfig){
        return (
          <div
            style={
              'width: 100%;padding-left: 24px;display:flex;align-items:center;box-sizing: border-box;'
            }
          >
            <span class="ly-tree-node">
              <span class="tree_name" style='width:55%' title={node.label}>
                {node.label}
              </span>
            </span>
            <span class="ly-visible" style={'width:50px;height:15px;right:74px;'+ (node.level <= 3 ? 'display:none;' : '')}>
                {node.level<= 4? this.$t('deviceMsg.area2'): this.$t('deviceMsg.group')}
                <input
                  maxlength="32"
                  class="ly-edit__text"
                  on-blur={(e) => this.configNameChange(e, data, node)}
                  value={node.data.configName}
                  style={'width:50px;height:15px;'}
                />
            </span>
            {
              node.data.isRepeatAreaNo ? 
                <span style={'color:red;'}>
                  { this.$t('notices.areaCodeError') }
                  </span> 
                : ''
            }
          </div>
        )
      }
      

      if (
        data.IsLeaf != undefined &&
        data.IsLeaf == true &&
        data.level != null
      ) {
        this.$store.state.projectarealevel = data.level
      }
      // this.$store.dispatch('updateGpName', {"Gpno":data["id"], "GpName": (data["xname"] || data["name"])});
      if (data.id == this.gpno) {
        data.switch = true
      }
      return (
        <div
          style={
            'width: 100%;padding-left: 24px;box-sizing: border-box;' +
            (this.is_switch ? 'width: calc( 100% - 50px );' : '')
          }
        >
          <span
            class="ly-tree-node"
            style={
              this.limitLevel != null &&
                this.limitLevel.indexOf(data.level) != -1
                ? 'cursor: not-allowed;opacity: 0.5;color: #795548;'
                : ''
            }
          >
            {(this.isEdit === true && this.isSelect(data)) || data.isEdit ? (
              <input
                maxlength="32"
                placeholder={this.$t('tree.addmsg')}
                class="ly-edit__text"
                on-click={() => this.nameChange()}
                on-keyup={(e) => this.nameChange(e, data, node)}
                value={this.edit_name}
                onEnter={this.editMsg}
              />
            ) : (
             <div style={
                  this.is_switch
                    ? 'width: calc( 100% - 25px);'
                    : 'width: calc( 100% - 20px - ' +
                    10 * (data.countTotal + '').length +
                    'px )'
                 }
                 class={'tree_name_box'}
                >
              <span
                class="tree_name"
                style={
                  'max-width: calc( 100% - 25px);'
                }
                title={data.name}
              >
                {data.name}
              </span>
              {Boolean(data.Path) && this.isMap &&<img src={require("@/assets/img/visual/path.png")} class={'PathIcon'}/>}
             </div>
                

              
            
              
              // <span class='tree_name' style={this.is_switch?'width: calc( 100% - 25px);':((data.UpdateArea || data.AddArea || data.AddArea || data.DeleteArea || data.UpdateArea)?'':('width: calc( 100% - '+ ( 10*(data.countTotal+'').length)+'px )'))} title={data.name}>{data.name}</span>
            )}
           
            {(this.isEdit === true && this.isSelect(data)) || data.isEdit
              ? getEditContent.call(this, h, data, node)
              : getDefaultContent.call(this, h, data, node)}
            {
              <span
                class={this.areaTreeType == 1 ? 'tree_count' : ''}
                style={
                  'position: absolute;right: 0;margin-right: 10px;padding: 0 5px;font-style: normal;'
                }
              >
                {data.countTotal}
              </span>
            }
          </span>
          {
            // this.areaTreeType != 1 && data.count != undefined ?(<span class={this.areaTreeType == 1?'':'tree_iftttcount'} style={((data['IsLeaf'] == undefined && data.level == 4)||(data['IsLeaf'] != undefined && data['IsLeaf']==true))?'display:none;':''+"font-size: 12px;height: 20px;align-items: flex-end;opacity: 0.3;"}>{this.$t('tree.selfArea')}:{data['count']} &nbsp;&nbsp;{(this.areaTreeType != 1 && data['child'] != null)?(this.$t('tree.subArea')+'：'):''}{(this.areaTreeType != 1 && data['child'] != null)?this.totalChildCount(data['child']):''}</span>):''
            this.areaTreeType != 1 && data.count != undefined
              ? (
              <span
                class={this.areaTreeType == 1 ? '' : 'tree_iftttcount'}
                style={
                  (data.IsLeaf == undefined &&
                    data.level == this.$store.state.projectarealevel) ||
                    (data.IsLeaf != undefined && data.IsLeaf == true)
                    ? 'display:none;'
                    : '' +
                    'font-size: 12px;height: 20px;align-items: flex-end;opacity: 0.3;'
                }
              >
                {this.$t('tree.selfArea')}:{data.count} &nbsp;&nbsp;
                {this.areaTreeType != 1 && data.child != null
                  ? this.$t('tree.subArea') + '：'
                  : ''}
                {this.areaTreeType != 1 && data.child != null
                  ? this.totalChildCount(data.child)
                  : ''}
              </span>
                )
              : (
                  ''
                )
          }
          {this.areaTreeType != 1 &&
            data.count != undefined &&
            data.child != null &&
            data.child.length > 0
            ? (
            <div
              class="el-tree-node-last-line-tance"
              style="position: absolute;top: 20px;bottom: 0;left: 0;margin-left: 12px;border-left: 1px dashed #e6e6e6;"
            ></div>
              )
            : (
            <div></div>
              )}
        </div>
      )
    },
    totalChildCount (item) {
      if (item != null && item.length > 0) {
        let count = 0
        item.forEach((item) => {
          if (typeof item.count === 'number') {
            count += item.count
          }
          if (
            this.areaTreeType != 1 &&
            item.child != null &&
            item.child.length > 0
          ) {
            count += this.totalChildCount(item.child)
          }
        })
        return count
      }
      return 0
    }
  }
}
</script>
<style lang="scss">
/* tree样式 */
.el-tree-node__dragging {
  height: 10px;
}
.filterText {
  margin: 0 10px;
}
.opple-tree-container {
  overflow: scroll;
}
.new_block {
  border: 15px solid transparent;
  border-width: 6px;
  border: 2px dashed red\9;
  border: 1px dashed #d3d3d3;
  font-size: 14px;
  color: #c9c9c9;
  text-align: center;
  height: 32px;
  line-height: 32px;
  margin: 0 10px;
  margin-top: 10px;
}
.switchCss {
  position: absolute;
  border: none;
  background: transparent;
  top: 5px;
  right: 5px;
  height: 18px;
  /*padding: 0px 5px 2px 3px;*/
  width: 23px;
  height: 18px;
}
.ly-tree-container-check .el-tree-node__content > .el-checkbox {
  margin-right: 8px;
  position: absolute;
  right: 0px;
  top: 5px;
}

.tree-area-title {
  position: relative;
  display: inline-block;
  width: auto;
  height: 18px;
  font-size: 16px;
  font-weight: bold;
  color: #0046aa;
  z-index: 1;
  overflow: hidden;
}

.ly-tree-node {
  cursor: pointer;
  box-sizing: border-box;
}
.gray {
  .check-icon {
    background-color: #edf2fc !important;
    border: 1px solid #dcdfe6 !important;
    color: #dcdfe6 !important;
    cursor: not-allowed !important;
  }
}
.white-icon {
  background-color: #fff;
  border: 1px solid #dcdfe6;
  color: #fff;
}
.check-icon {
  background-color: #409eff;
  border: 1px solid #409eff;
  color: #fff;
}
.reset_width-394{
  width: 394px;
}

.el-icon-tree-top{
   transform: rotate(180deg);
  
}
.PathIcon{
  width: 21px;
  height: 17px;
  margin-bottom: 5px;
  margin-left: 4px;
}
.tree_name_box{
  display: flex;
  align-items: center;
  flex-direction: row
}
.ly-tree-container .el-tree-node__content:hover .PathIcon {
  display: none;
}
.tree_name{
  overflow: hidden;
    //white-space: nowrap;
    //text-overflow: ellipsis;
    display: block;
    box-sizing: border-box;
}
.ly-tree-container .leve_add .el-icon-plus {
   top:50%;
   transform: translate3d(0,-50%,0);
}
.ly-tree-container .tree_button .upload{
  display: block;
  width: 14px;
  height: 14px;
  margin-top: 5px;
}

.uploadAreaTreeExcel_dialog{
  .opDialog_head{
    background: #E3E8F3;
    .opDialog_title{
      color: #3D3D3D;
      font-size: 13px;
    }
    .opDialog_close{
      color: #3D3D3D;
    }
  }
  .opDialog_body{
    padding: 10px;
    .uploadAreaTreeExcel_content * {
      box-sizing: border-box; 
    }
    .uploadAreaTreeExcel_content{
      display: flex;
      &_left{
        border-right:2px solid #D8E1EB;
        padding:0 50px;
        .title{
          font-size: 22px;
          color: #3D3D3D;
          font-weight: 600;
          margin-top: 10px;
          margin-bottom: 10px;
        }
        .note{
          font-size: 16px;
          color: #6D6D6D;
        }
        .excel{
          text-align: center;
          margin-top: 100px;
          margin-bottom: 90px;
          img{
            width: 156px;
            height: 120px;
          }
          .template{
            font-size: 18px;
            color: #000000;
          }
        }
        .download{
          padding: 10px;
          display: flex;
          justify-content: center;
          color: #0045A9;
          .button{
            width: 200px;
            height: 50px;
            border: 1px solid #C2C4C8;
            border-radius: 6px;
            text-align: center;
            line-height: 50px;
            cursor: pointer;
          }
      }
    
      }
      &_right{
        position: relative;
        width: 700px;
        margin: 0 auto;
        .header{
          margin-top: 10px;
          display: flex;
          align-items: flex-end; /* 让子元素底部对齐 */
          .title{
            font-weight: 600;
            font-size: 22px;
            color: #3D3D3D;
            margin-right: 20px;
          }
          .note{
            font-size: 16px;
            color: #6D6D6D;
          }
        }
        .upload_container{
          .upload_box{
            margin: 10px auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 700px;
            height: 300px;
            border: 2px solid #D8E1EB;
            img{
              width: 20px;
              height: 20px;
            }
            p:nth-of-type(1){
              color: #000000;
            }
            p:nth-of-type(2){
              margin: 10px 0;
              color: #848484;
            }
            button{
              width: 120px;
              height: 40px;
              border-radius: 6px;
              background: #0145A9;
              color: #FFFFFF;
              border: none;
            }
          }
          .file{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 10px 0;
            img{
              width: 20px;
              margin-right: 20px;
            }
            &_info{
              span:nth-of-type(1){
                font-size: 18px;
                font-weight: 600;
                color: #3D3D3D;
                margin-right: 20px;
              }
              span:nth-of-type(2){
                font-size: 18px;
                color: #6D6D6D;
              }
            }
            p{
              margin-top: 10px;
              font-size: 18px;
              color: #6D6D6D;
            }
          }
        }
        .button_container{
          position: absolute;
          right: 0;
          bottom: 0;
          display: flex;
          button:nth-of-type(1){
            width: 120px;
            height: 40px;
            margin-right: 20px;
            background: #0145A9;
            border-radius: 6px;
            color: #FFFFFF;
            border:none;
          }
          button:nth-of-type(2){
            width: 120px;
            height: 40px;
            border-radius: 6px;
            color: #000000;
            background: #FFFFFF;
            border: 1px solid #C2C4C8;
          }
        }
      }
    }
  }
}
.filterText {
  .select-style {
    width: 100%;
  }
}
  

</style>
